import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

function BookSplatRedirect() {
  useEffect(() => {
    window.location.replace(window.location.href);
  }, []);
  return null;
}

export const Route = createFileRoute("/book/$")({
  component: BookSplatRedirect,
});
